import {encode} from 'js-base64';

const VERSION = "V2:";

export function encoded(text) {
    let encoded = encode(text);
    return VERSION + encoded;
}